import React, { Component, Fragment } from 'react'

import TableRow from '../../components/TableRow/'
import { TableHeader, HeaderItem } from './styles'

class Table extends Component {
  handleEdit(item) {
    this.props.onEditClick(item)
  }

  render() {
    const {
      headers,
      items,
      editable,
      editType,
      deleteTitle,
      deleteConfirm,
      deleteReject,
      deleteUser,
      data,
      loading,
      error,
      deleteUserPermission,
      editUserPermission
    } = this.props

    return (
      <Fragment>
        <TableHeader>
          {headers.map((header, index) => {
            return <HeaderItem key={index}> {header}</HeaderItem>
          })}

          <HeaderItem />
        </TableHeader>

        {items.map(item => {
          let fullUser = ''
          if (this.props.fullUsers) {
            fullUser = this.props.fullUsers.find(fullUser => fullUser.id === item.id)
          }
          return (
            <TableRow
              key={item.id}
              item={item}
              fullUser={fullUser}
              editable={editable}
              editType={editType}
              headers={headers}
              editUserPermission={editUserPermission}
              onEditClick={this.handleEdit.bind(this, item)}
              deleteUserPermission={deleteUserPermission}
              deleteTitle={deleteTitle}
              deleteConfirm={deleteConfirm}
              deleteReject={deleteReject}
              deleteUser={deleteUser}
              data={data}
              loading={loading}
              error={error}
              currentUser={this.props.currentUser}
            />
          )
        })}
      </Fragment>
    )
  }
}

export default Table



// WEBPACK FOOTER //
// ./src/components/Table/index.js